
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppAdministratorResourcesSupplementsListFormRemove} from "@/models/app/administrator/resources/supplements/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "supplement",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppAdministratorResourcesSupplementsListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  supplement: AppAdministratorResourcesSupplementsListFormRemove = new AppAdministratorResourcesSupplementsListFormRemove();

  formData: AppAdministratorResourcesSupplementsListFormRemove = new AppAdministratorResourcesSupplementsListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/administration/supplement/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getSupplements');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.supplement;
  }

  resetFormData(): void {
    this.formData = new AppAdministratorResourcesSupplementsListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
